import React, { useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons'
import styles from './AudioButton.module.scss'

const AudioButton = ({ audioSrc }: { audioSrc: string }) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [isPlaying, setIsPlaying] = useState<boolean>(false)

  const handleAudioClick = () => {
    if (audioRef.current) {
      if (audioRef.current.paused) {
        setIsPlaying(true)
        audioRef.current.play()
      } else {
        setIsPlaying(false)
        audioRef.current.pause()
      }
    }
  }

  return (
    <div>
      <div className={styles.audio}>
        <audio ref={audioRef} src={audioSrc} />
        <FontAwesomeIcon
          icon={faVolumeUp}
          onClick={handleAudioClick}
          beat={isPlaying ? true : false}
        />
      </div>
    </div>
  )
}

export default AudioButton
